import { ApiCallsFactory } from '../../factories/APIcalls/index'

const pingLogOut = async (
  { token } : { token: string }
) => {
  try {
    const logOut = new ApiCallsFactory('/user/logout', token);
    const response : any = await logOut.getData()
    window.sessionStorage.clear()
    window.localStorage.clear()
    console.log(`${process.env.REACT_APP_SSO_LOGOUT_UP}id_token_hint=${response?.idToken}&post_logout_redirect_uri=${process.env.REACT_APP_SSO_LOGOUT}/sign-in`)
    if (response?.idToken) {
        window.location.href = `${process.env.REACT_APP_SSO_LOGOUT_UP}id_token_hint=${response?.idToken}&post_logout_redirect_uri=${process.env.REACT_APP_SSO_LOGOUT}/sign-in`
    }
  } catch (error) {
    return console.error(`pingLogOut Error --> ${error}`)
  }
}

const getSession = () => {
  const authBaseURI = process.env.REACT_APP_SSO_AUTH_BASE_URI
  const clientId = process.env.REACT_APP_SSO_CLIENT_ID
  const redirectUri = process.env.REACT_APP_SSO_REDIRECT_URI

  const authURI = `${authBaseURI}/as/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}`

  return window.location.href = authURI
}

export {
  pingLogOut,
  getSession
}
